module.exports = __webpack_public_path__ + "static/media/588JamesPBrawleyDrNW_2018-06-12_180.71030d8b.jpg";